export default {
  en: {
    utils:{
      locale: 'ar'
    },
    loading:{
      loading: 'Loading ..',
      error: 'Oops, something went wrong'
    },
    navbar: {
      home: 'Home'
    }
  },
  ar: {
    utils:{
      locale: 'en',
    },
    loading:{
      loading: 'جار التحميل ..',
      error: 'تبا شيء ما حدث بشكل خاطئ'
    },
  },
};



// WEBPACK FOOTER //
// ./src/translations/messages.js